<template>
  <div class="hour-cell">

    <TrendIcon  v-if="params.value || this.hasValue()" 
                :Difference="this.trend" 
                :inverted="cancelInvertion ? true : this.isInverted"
                class="dim-rect"/>

    {{ this.getTime(params.value) }} 

    <AccomplishmentIcon v-if="hasAccomplished()" 
                        :isAccomplished="isAccomplished()" />

    <b-button v-if="params.value && this.rowProperty && getSurveyInstance()"
              variant="outline-secondary" 
              @click="downloadReportForSurveyInstance(getSurveyInstance())"
              size="sm" 
              class="mr-2"
              v-b-tooltip.hover.nofade="toolTipDelay" 
              :title="$t('Webportal.CX.Margin.DownloadCheckReportTooltip')">
      <small>
        <font-awesome-icon :icon="['fas', 'file-pdf']" />
      </small>
    </b-button>
    
  </div>
</template>

<script>
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";
import CellRendererMixin from '@/mixins/jlr/CellRendererMixin';
import dateTime from "./dateTime";
import DownloadFileMixin from '@/mixins/DownloadFileMixin';
import TrendIcon from "@/components/Shared/TrendIcon";

export default {
  mixins: [
    CellRendererMixin, DownloadFileMixin
  ],
  
  components: { 
    AccomplishmentIcon, TrendIcon
  },
  
  data() {
    return {
      // isInverted: true
    };
  },

  computed: {
    cancelInvertion() {
      if (this.isPreviousNull === false && this.isCurrentNull === true) {
        return true;
      } else if (this.isPreviousNull === true && this.isCurrentNull === false) {
        return true;
      } else {
        return false;
      }
    },
    isCurrentNull() {
      if (this.rowProperty?.[this.params?.localIndex]?.result === null) return true;
      else return false;
    },
    isPreviousNull() {
      if (this.rowProperty?.[this.params?.localIndex + 1]?.result === null) return true;
      else return false;
    },
    isInverted() {
      if(this.rowProperty?.[this.params?.localIndex]?.ThresholdDirection === 'ABOVE') {
        return false;
      } 
      return true;
    },
  },
  
  methods: {
    hasValue() {
      if (this.params.value) {
        return this.params.value.toString().trim().length > 0;
      }
      else if (this.params.value === undefined) return false;
      else if (this.params.value === null) return true;
      else return this.params.value.toString().trim().length > 0;
    },

    getTime(minutes) {
      if (minutes === 0) return '0:00h';
      else if (minutes === undefined) return;
      else if (minutes === null) return 'N/A';
      else return dateTime.formatHoursMinutes(parseInt(minutes));
    }
  }
}
</script>

<style lang="scss" scoped>
  .hour-cell {
    width: 100%;
    text-align: left;
  }
</style>